import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {CmsCopy, gqlPaginatorInfo, PaginatiorInfo} from '../../graphql/common.datatypes';
import {gqlCmsCopy} from './getCmsCopy.api';

interface CmsCopysData {
    cmsCopys: {
        data: CmsCopy[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_CMS_COPYS_QUERY = gql`
  query cmsCopys($count: Int!, $page: Int!, $where: WhereConditions, $orderBy: [OrderByClause!]){
    cmsCopys(first: $count, page: $page, where: $where, orderBy: $orderBy){
      data {
        ${gqlCmsCopy}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getCmsCopys = (count: number, page: number, where?: any, orderBy?: any) => useQuery<CmsCopysData>(
    GET_CMS_COPYS_QUERY,
    {
        variables: {
            count,
            page,
            where,
            orderBy,
        },
    }
);

export default getCmsCopys;
